/**
 * Player Stats Overlay Component
 * 
 * Displays player stats and stamina bar
 */

import React from 'react';
import { usePlayer } from '../contexts/PlayerContext';
import { useAuth } from '../contexts/AuthContext';

export const PlayerStatsOverlay: React.FC = () => {
  const { player, position } = usePlayer();
  const { user } = useAuth();
  
  // Use Firebase Auth displayName if available, otherwise fall back to player.name
  const displayName = user?.displayName || player.name;
  
  return (
    <div
      style={{
        position: 'absolute',
        top: 15,
        right: 15,
        background: 'linear-gradient(135deg, rgba(139, 115, 85, 0.95) 0%, rgba(106, 90, 69, 0.95) 100%)',
        border: '3px solid #5a4a35',
        borderRadius: '8px',
        padding: '12px 16px',
        color: '#fff',
        fontFamily: "'Cinzel', serif",
        fontSize: '14px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.6)',
        zIndex: 10,
        minWidth: '180px',
      }}
    >
      <div style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '16px', borderBottom: '2px solid #8b7355', paddingBottom: '4px' }}>
        {displayName}
      </div>
      <div style={{ marginBottom: '4px' }}>
        <span style={{ opacity: 0.8 }}>Position:</span> ({position.q}, {position.r})
      </div>
      <div style={{ marginBottom: '4px' }}>
        <span style={{ opacity: 0.8 }}>Stamina:</span> {player.stamina}/{player.maxStamina}
      </div>
      {/* Stamina bar */}
      <div style={{ marginTop: '6px', marginBottom: '8px', background: 'rgba(0, 0, 0, 0.4)', borderRadius: '4px', height: '8px', overflow: 'hidden' }}>
        <div
          style={{
            width: `${(player.stamina / player.maxStamina) * 100}%`,
            height: '100%',
            background: player.stamina > player.maxStamina * 0.5 
              ? 'linear-gradient(90deg, #4ade80 0%, #22c55e 100%)'
              : player.stamina > player.maxStamina * 0.25
              ? 'linear-gradient(90deg, #fbbf24 0%, #f59e0b 100%)'
              : 'linear-gradient(90deg, #ef4444 0%, #dc2626 100%)',
            transition: 'width 0.3s ease',
          }}
        />
      </div>
    </div>
  );
};

